import { createSlice } from '@reduxjs/toolkit';

// Remarks: for easy using about uploading impression file
// the impression file error message is refered to newPatientReducer (old and not readable version)
export const uploadFileSlice = createSlice({
    name: 'uploadFile',
    initialState: {
        impressionData: {},
        handleImpressionData: () => {}, // Purpose: Pass the handlDataSave to your component to trigger validation in newPatientReducer
    },

    reducers: {
        setImpressionData: (state, action) => {
            state.impressionData = action.payload;
        },
        setHandleImpressionData: (state, action) => {
            state.handleImpressionData = action.payload;
        },
    },
});

export const { setImpressionData, setHandleImpressionData } = uploadFileSlice.actions;

export default uploadFileSlice.reducer;
